import firebase from 'firebase'
var config = {
    apiKey: "AIzaSyC-rzgXSL5Vhi4BPOx4C2Ti5J5TQKn4A4k",
    authDomain: "offer-swap.firebaseapp.com",
    databaseURL: "https://offer-swap.firebaseio.com",
    projectId: "offer-swap",
    storageBucket: "offer-swap.appspot.com",
    messagingSenderId: "655191476380"
};
// Here we are initializing the Firebase connection.
let app = firebase.initializeApp(config)
let db = app.database()
export default db


// WEBPACK FOOTER //
// ./src/components/db.js